import SEO from "../components/SEO";
import seoData from "../seoData";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { Features } from "../components/features";
import JsonData from "../data/data.json";

const FeaturesPage = () => (
  <>
    {/* SEO Meta */}
    <SEO {...seoData.features} />
    <BreadcrumbSchema
      items={[
        { name: "Home", url: "/" },
        { name: "Features", url: "/features" },
      ]}
  />
    <Features data={JsonData.Features} />
  </>
);

export default FeaturesPage;
